<script setup lang="ts">
import type { Product } from '~/config'

interface Props {
  product: Product
}

defineProps<Props>()
</script>

<template>
  <div class="relative grow-hover overflow-hidden rounded-md">
    <ImageComponent
      :id="`${product.code}-artwork`"
      :src="`/siteAssets/img|product-cards/${product.bannerFile}`"
      :alt="product.name"
      class="absolute z-0 h-full w-full object-cover"
    />
    <div class="z-1 relative flex aspect-[16/9] flex-col justify-between items-start p-[5%]">
      <ImageComponent
        :id="`${product.code}-artwork-icon`"
        :src="`/siteAssets/img|product-icons/${product.iconFile}`"
        :alt="product.name"
        class="rounded-md size-8 lg:size-11"
      />
      <div
        class="bg-white/40 backdrop-blur-sm backdrop-grayscale rounded-full px-2 text-xs md:text-sm lg:text-lg xl:text-2xl"
      >
        <span
          class="font-bold uppercase text-surface-950 leading-tight text-base md:text-sm xl:text-base"
        >
          {{ product.alias ?? product.name }}
        </span>
      </div>
    </div>
  </div>
</template>
